// src/components/IframePopup.js
import '../css/IframePopup.css'; // Don't forget to create this CSS file

const IframePopup = ({ url, onClose, isOnline }) => {
    let title = "Online Content";

   

    return (
        <div className="popup-overlay">
            <div className="popup-content">
                {/* New Title Bar */}
                <div className="popup-title-bar">
                    <button className="popup-close-button close-left" onClick={onClose}>
                        &times; {/* Left close button */}
                    </button>
                    <h2 className="popup-title">{title}</h2> {/* Title */}
                    <button className="popup-close-button close-right" onClick={onClose}>
                        &times; {/* Right close button */}
                    </button>
                </div>

                {isOnline ? <iframe
                    src={url}
                    title={title} // Use the title prop for accessibility
                    className="popup-iframe"
                    frameBorder="0"
                    allowFullScreen
                ></iframe> : <div style={{
                                    color: 'red',
                                    display: 'flex',
                                    flexDirection: 'column', // Stack children vertically
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    height: '100%', // Takes full height of parent
                                    width: '100%',  // Takes full width of parent
                                    textAlign: 'center'
                                    }}>
                                    <div><strong>i-TEAM is not online right now!</strong><br /></div>
                                    <div>This content is available only when the i-TEAM is online.</div>
                                    <div>Please check your internet connection!</div>
                              </div>
                }
            </div>
        </div>
    );
};

export default IframePopup;